export default function Spacer({ backgroundColor, flex, height, width }) {
  return <div style={{ height, flex, width, backgroundColor }} />;
}
